import { formatDate } from 'src/utils/dates';
import { DateColumnFormat } from './ColumnFormatters/DateColumnFormat';
import { ActionColumnDowload } from './ColumnFormatters/ActionColumnDowload';

//-------------------------MIEMBROS--------------------------------//
export const columnsMember = [
	{
		dataField: 'nombre',
		text: 'Nombre',
	},
	{
		dataField: 'cargo',
		text: 'Cargo',
	},
];

//----------------PreviousSessions----------------------------------//
export const columnsPreviousSessions = [
	{
		dataField: 'fecha',
		text: 'Fecha',
		//formatter: (value) => value + ' hrs',
	},
	{
		dataField: 'numero_sesion',
		text: 'Sesion',
		classes: 'text-primary',
	},
];

//-----------------UpcomingSessions--------------------------------//
export const columnsUpcomingSessions = [
	{
		dataField: 'hourAndDate',
		text: 'Fecha',
		formatter: DateColumnFormat,
	},
	{
		dataField: 'organAndSession',
		text: 'Consejo',
	},
];

export const defaultSessions = {
	id: '',
	hourAndDate: '',
	organAndSession: '',
};

//-------------------FILE VERSIONS OD ----------------------------//
export const columnsRecord2 = (onDownload) => [
	{
		dataField: 'nombre',
		text: 'Nombre',
		classes: 'text-center',
	},

	{
		dataField: 'ruta',
		text: 'Documento',
		classes: 'text-center',
		formatter: ActionColumnDowload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'nombreUsuario',
		text: 'Usuario',
		classes: 'text-center',
	},
	{
		dataField: 'fecha',
		text: 'Fecha',
		classes: 'text-center',
		formatter: (value) => {
			return formatDate('P', new Date(value));
		},
	},
	{
		dataField: 'hora',
		text: 'Hora',
		classes: 'text-center',
		formatter: (value) => {
			return formatDate('HH:mm', new Date(value));
		},
	},
];

//-----------------NewSession------------------------------------//
export const labelsNewSession = (disableForm) => [
	{
		label: '*Nombre Corto de Sesión',
		name: 'nombre_corto',
		type: 'text',
		column: 6,
		disabled: disableForm,
	},
	{
		label: '*Tipo de Sesión',
		name: 'tipo_sesion',
		type: 'dropdown',
		options: [
			{ value: 'O', text: 'Ordinaria' },
			{ value: 'E', text: 'Extraordinaria' },
		],
		column: 6,
		disabled: disableForm,
	},
	{
		label: '*Fecha y Hora',
		name: 'fhora',
		type: 'date-time',
		column: 6,
		disabled: disableForm,
	},
	{
		label: '*Lugar',
		name: 'lugar',
		type: 'text',
		column: 6,
		disabled: disableForm,
	},
	{
		label: 'Direccion',
		name: 'direccion',
		type: 'text',
		column: 6,
		disabled: disableForm,
	},
	{
		label: 'Aviso',
		name: 'aviso',
		type: 'text',
		column: 6,
		disabled: disableForm,
	},
	{
		label: '*Fundamento Juridico',
		name: 'fundamento_juridico',
		type: 'text',
		column: 12,
		adjustable: true,
		disabled: disableForm,
	},
];
export const labelsOrganSelected = (organs, disableForm = false) => [
	{
		label: '*Órgano Colegiado',
		name: 'organoId',
		type: 'dropdown',
		column: 12,
		options: [...organs],
		disabled: disableForm,
		organ: '',
	},
	{
		label: '*Número de Sesión',
		name: 'numero_sesion',
		type: 'text',
		column: 12,
		disabled: disableForm,
	},
];
export const defaultOrganSelected = {
	organoId: '',
};

export const defaultNewSession = {
	tipo_sesion: '',
	numero_sesion: '',
	fhora: new Date(),
	nombre_corto: '',
	fundamento_juridico: '',
	organoId: '',
	nameOrgan: '',
	publicada: '',
	aviso: '',
	direccion: '',
	lugar: '',
};

export const defaultOrgan = { value: 1, text: 'Ordinaria' };

export const action_buttonsNewSession = (onSave) => [
	{ title: 'Publicar y Enviar Sesión', color: 'primary', onClick: onSave },
];

export const btnsCreate = (onSave, id, onEdit, hide) => [
	{
		title: id === undefined ? 'Crear Sesión' : 'Actualizar Sesión',
		onClick: onSave,
		className: hide ? 'd-none' : 'mt-lg-5 float-right',
	},
	{
		title: 'Cancelar',
		color: 'light-danger',
		onClick: onEdit,
		className: hide ? 'd-none' : 'mt-lg-5 float-right m-4',
	},
];

export const btnsPublishedStatus = (setAttendance, setNotifyChanges) => [
	{
		title: 'Notificar cambios',
		onClick: setNotifyChanges,
		className: 'col-sm-5 mt-4 ml-lg-4',
	},

	{
		title: 'Asistencia a la sesión',
		onClick: setAttendance,
		className: 'col-sm-6 mt-4 ml-lg-2',
	},
];

export const sessionTabsAll = [
	{ value: 1, label: 'Orden del día' },
	{ value: 2, label: 'Convocatoria' },
	{ value: 3, label: 'Documentos' },
];

export const sessionTabs2 = [
	{ value: 1, label: 'Orden del día' },
	{ value: 3, label: 'Documentos' },
];
